const ErrorPage = () => {
  return (
    <div className="flex justify-center items-center min-h-[400px]">
      <h1 className="text-3xl font-bold text-gray-800">Error 404: Could not find page!</h1>
    </div>
  );
};

export default ErrorPage;
